import ApiBase from './ApiBase';
import axios from 'axios';

/**
 * Investor Tag API
 */
class InvestorTagApi extends ApiBase {
  /**
   * Check if Investor Tag Name already exists
   * @param {*} investorTagName
   */
  async checkInvestorTagNameExists(investorTagName) {
    const request = {
      url: `${this.API_URL}/investortag?name=${investorTagName}`,
      headers: this.getHeaders(),
      method: 'HEAD',
      validateStatus: function(status) {
        return (status >= 200 && status < 300) || status === 404;
      }
    };

    const response = await axios.request(request);

    if (response.status === 200) {
      return true;
    } else if (response.status === 404) {
      return false;
    } else {
      throw Error('An error has occurred');
    }
  }

  /**
   * Create Investor Tag
   * @param payload { name: investorTagName }
   */
  async create(payload) {
    const request = {
      url: `${this.API_URL}/investortag`,
      headers: this.getHeaders(),
      method: 'POST',
      data: payload
    };

    const response = await axios.request(request);

    return response.data;
  }

  /**
   * Update Investor Tag Name
   * @param id
   * @param payload { name: investorTagName }
   */
  async update(id, payload) {
    const request = {
      url: `${this.API_URL}/investortag?id=${id}`,
      headers: this.getHeaders(),
      method: 'PUT',
      data: payload
    };

    const response = await axios.request(request);

    return response.data;
  }

  async downloadInvestorTagImportTemplate() {
    const request = {
      url: `${this.API_URL}/investortag/import/template`,
      method: 'GET',
      headers: this.getHeaders(),
      responseType: 'blob'
    };

    const response = await axios.request(request);
    return response.data;
  }

  async validateImportFromExcel(payload) {
    const request = {
      url: `${this.API_URL}/investortag/validateimport`,
      method: 'POST',
      headers: this.getHeaders(),
      data: payload
    };
    const response = await axios.request(request);

    // Handle Gateway Timeout
    if (response.status === 504) {
      throw new Error('The request took too long and timed out.');
    }

    return response.data;
  }

  async importInvestorTagFromExcel(payload) {
    const request = {
      url: `${this.API_URL}/investortag/importexcel`,
      method: 'POST',
      headers: this.getHeaders(),
      data: payload
    };
    const response = await axios.request(request);

    // Handle Gateway Timeout
    if (response.status === 504) {
      throw new Error('The request took too long and timed out.');
    }

    return response.data;
  }

  async exportInvestorTagToExcel(nameFilter, selectedIds) {
    if (nameFilter.trim() === '') {
      nameFilter = undefined;
    } else {
      nameFilter = '*' + nameFilter + '*';
    }

    let payload;
    if (selectedIds && selectedIds.length > 0) {
      payload = {
        tagIds: selectedIds
      };
    } else {
      payload = {
        name: nameFilter
      };
    }

    const request = {
      url: `${this.API_URL}/investortags/excel/export`,
      method: 'POST',
      headers: this.getHeaders(),
      responseType: 'blob',
      data: payload
    };

    const response = await axios.request(request);

    // Handle Gateway Timeout
    if (response.status === 504) {
      throw new Error('The request took too long and timed out.');
    }

    return response.data;
  }
}

export default new InvestorTagApi();
